import * as React from 'react';
import './welcome.css'
import Utils from "../../../Utils";

const welcomePage = (props: any) => {
    const tip = Utils.$('<div id="qtipWelcome"></div>')
        .append($("<label style='font-size: 12px'>It seems that you don't have any permissions.</label>"))
        .append($("</br>"))
        .append($("<label style='font-size: 12px'>Please, contact the administrator.</label>"));

    const showTip = (e) => {
        const helpTip = tip.clone();
        Utils.$(e.target).qtip({
            content: {
                title: function () {
                    return "Tip:"
                },
                text: helpTip,
                button: "Close"
            },
            show: true,
            hide: "unfocus",
            position: {
                my: 'top right',
                at: 'bottom center',
                viewport: $(document.body)
            },
            style: {
                classes: 'qtip-dark',
                width: 350
            }
        });
    }

    return (
        <div id={'welcome-wrapper'} style={{backgroundColor: '#2D3436', height: '100%'}}>
            <header style={{height: 50, display: "flex"}} className="bo-core-header top-header">
                <div style={{
                    float: "left",
                    paddingLeft: 4,
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center"
                }}>
                    <i className="fas fa-question-circle help-btn" onClick={showTip}/>
                </div>
            </header>
            <div id={'welcome'}>
                <div>
                    <h1 className={'text-align-center'} style={{fontSize: '19rem', color: '#9a9a9a', fontWeight: 600}}>Welcome</h1>
                    <h1 className={'text-align-center'} style={{fontSize: '7rem', color: '#9a9a9a'}}>To BoCore</h1>
                </div>
            </div>
        </div>
    )
}
export default welcomePage;



// WEBPACK FOOTER //
// ./app/views/bo-core/welcome/Welcome.tsx